<template>
  <v-container class="dashboard-container">
    <v-row class="mt-4 text-blue-color">
      <v-col class="pb-0">
        <div class="underline-text px-3">
          Overview
        </div>
      </v-col>
    </v-row>

    <v-row class="justify-center">
      <v-col cols="12" md="4" class="d-flex justify-center column-col">
        <a href="/offerings" class="column-content shadow-column">
          <div class="logo-container">
            <div class="circle">
              <i class="fa fa-bars navbar-item-icon"></i>
            </div>
          </div>
          <h2 class="column-title text-blue-color">My<br> Offerings</h2>
        </a>
      </v-col>
      <v-col cols="12" md="4" class="d-flex justify-center column-col">
        <a href="/dashboard/index" class="column-content shadow-column">
          <div class="logo-container">
            <div class="circle">
              <i class="fa fa-pie-chart navbar-item-icon"></i>
            </div>
          </div>
          <h2 class="column-title text-blue-color">My<br> Dashboard</h2>
        </a>
      </v-col>
      <v-col cols="12" md="4" class="d-flex justify-center column-col">
        <a href="/profile/edit" class="column-content shadow-column">
          <div class="logo-container">
            <div class="circle">
              <span class="navbar-item-icon">{{ initials }}</span>
            </div>
          </div>
          <h2 class="column-title text-blue-color">My<br> Profile</h2>
        </a>
      </v-col>
    </v-row>

    <v-row class="my-5" dense>
      <v-col cols="12" md="6" class="d-flex justify-center align-center" v-if="canAccessConsole">
        <a :href="adminConsoleUrl" class="column-content-2">
          <div class="logo-container-2">
            <div class="circle">
              <i class="fa fa-dashboard"></i>
            </div>
          </div>
          <h2 class="flex-grow-1 text-center my-3">My Admin Console</h2>
        </a>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-center align-center">
        <!-- <a href="/admin/users" class="column-content-2"> 
            <div class="logo-container-2">
              <div class="circle">
                <i class="fa fa-question-circle"></i>
              </div>
            </div>
            <h2 class="flex-grow-1 text-center my-3">Help Center</h2>
          </a> -->
      </v-col>
    </v-row>

    <v-row class="mt-4 text-blue-color pb-5">
      <v-col class="pb-0">
        <div class="underline-text px-3">
          Weekly Industry News
        </div>
      </v-col>
    </v-row>

    <v-row class="justify-space-between align-lg-center homepage-news-letter pa-2 my-4 mx-5">
      <v-col cols="12" lg="6" class="mb-3 mb-lg-0">
        <h2 class="text-blue-color"><v-icon class="text-blue-color">mdi-dice-5</v-icon> Five For Friday</h2>
        <p class="text-blue-color">Access industry resources through DealPoint’s weekly newsletter, including industry
          news, webinars, virtual
          events, guides, articles, infographics, and more.</p>
      </v-col>
      <v-col cols="12" lg="5">

        <v-alert id="newsletter-form-submit-success" type="success" class="alert-success" dismissible
          v-if="hasNewsLetterSent">
          <div class="d-flex">
            <div class="flex-grow-1">
              You'll be sure to receive our weekly newsletter!
            </div>
          </div>
        </v-alert>
        <v-alert id="newsletter-form-submit-error" type="error" class="alert-error" dismissible
          v-if="isNewsLetterSentError">
          <div class="d-flex">
            <div class="flex-grow-1">
              {{ error }}
            </div>
          </div>
        </v-alert>
        <div class="input-card input-card-sm">
          <v-text-field class="subscribe-email-field" label="Enter email" solo type="email" v-model="email">
            <template #append>
              <button class="subscribe-button btn btn-primary btn-lg" plain @click="sendSubscriptionNewsletterEmail">
                Subscribe
              </button>
            </template>
          </v-text-field>
        </div>
        <p class="text-muted"><small>By providing your email, you agree to receive promotional emails from DealPoint. You
            can unsubscribe anytime.</small></p>
      </v-col>
    </v-row>


    <v-row class="mt-4 ">
      <v-col class="pb-0">
        <div class="underline-text px-3 text-blue-color">
          Promote a simplified way to raise capital!
        </div>
      </v-col>
    </v-row>
    <v-row class="justify-lg-between align-lg-center pa-2">
      <v-col cols="12" class="mb-3 mb-lg-0">
        <v-row class="justify-center">
          <v-col cols="auto" class="pr-2">
            <v-icon class="logo-share text-blue-color">mdi-share-variant</v-icon>
          </v-col>
          <v-col>
            <p class="text-blue-color">
              If you think the DealPoint platform can bring value to someone in the industry, click the button below to
              share. Our platform covers all stakeholders, including Exempt Market Dealers, Syndicates, Funds, and more.
            </p>
          </v-col>
        </v-row>
        <v-row class="ml-5">
          <a href="https://ca.linkedin.com/company/privatecapital" target="_blank" plain
            class="linked-in-color btn btn-primary">
            <i class="fa fa-linkedin"></i>
          </a>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>


<script>
import axios from 'axios'
export default {
  name: "LandingPage",
  data() {
    return {
      initials: window.userInitials || '',
      canAccessConsole: window.canAccessConsole || false,
      adminConsoleUrl: window.adminConsoleUrl || '',
      hasNewsLetterSent: false,
      isNewsLetterSentError: false,
      newsLetterError: '',
      email: '',
    }
  },
  mounted() {
    console.log(this.initials)
  },
  methods: {
    sendSubscriptionNewsletterEmail() {
      this.hasNewsLetterSent = false
      this.isNewsLetterSentError = false
      axios.post('homepage/news-letter', {
        email: this.email,
        source: 'Newsletter',
        name: 'N/A',
        topic: 'Five For Friday Subscription Request',
        notes: 'Please add this user to the mailing list',
      })
        .then(response => {
          this.hasNewsLetterSent = true
          console.log(response.data);
        })
        .catch(error => {
          this.isNewsLetterSentError = true
          if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;
            if (errors.email) {
              const emailError = errors.email[0];
              this.error = emailError
            }
          } else {
            console.log('An error occurred:', error.message);
            this.error = error.message
          }
        });

    }
  }
}
</script>
  